import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateNotificationSettingParams {
  userId: string; // site user id
  enabled: boolean;
}

export class UpdateNotificationSettingRequest extends Request<IUpdateNotificationSettingParams, IResult> {
  constructor(params: IUpdateNotificationSettingParams) {
    super('updateNotificationSetting', params);
  }
}
